import axios from 'axios'
import axiosCancel from 'axios-cancel'

axios.defaults.withCredentials = true
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// Intercepteur pour gérer les erreurs 419 (CSRF token expired) et 429 (Rate limiting)
axios.interceptors.response.use(
  response => response,
  async error => {
    if (error.response && error.response.status === 419) {
      // Rafraîchir le token CSRF
      try {
        await axios.get('/sanctum/csrf-cookie')
        // Réessayer la requête originale
        const config = error.config
        return axios.request(config)
      } catch (refreshError) {
        return Promise.reject(refreshError)
      }
    }
    
    // Pour les erreurs 429, on log mais on ne réessaie pas automatiquement
    // pour éviter les boucles infinies. Les composants gèrent leurs propres retries.
    if (error.response && error.response.status === 429) {
      const url = error.config?.url || 'unknown'
      // Ne log que si ce n'est pas déjà une tentative de retry (éviter le spam)
      if (!error.config._retry) {
        console.warn(`Rate limited (429) on ${url}. Component will handle retry.`)
      }
    }
    
    return Promise.reject(error)
  }
)

axiosCancel(axios)
const singleton = axios.create()

export default singleton
